import paymentsReducers from './reducers';

export * from './selectors';

export { default as paymentsTypes } from './types';
export { default as paymentsActions } from './actions';

export default paymentsReducers;
